// components/startProject/StartFAQ.jsx
import { FiPlus } from "react-icons/fi";
import "./faq.css";

const faqs = [
  {
    q: "How soon will you contact me after I submit the form?",
    a: "We usually respond within 4 business hours. For urgent queries, WhatsApp is the fastest way to connect.",
  },
  {
    q: "Do you sign an NDA before discussion?",
    a: "Yes. NDA and IP protection are standard at Oglitz. Your idea and data remain confidential from day one.",
  },
  {
    q: "Will I own the source code and IP?",
    a: "Absolutely. You receive 100% ownership of source code, designs, and intellectual property.",
  },
  {
    q: "Is there any obligation after the first call?",
    a: "No. The first discussion is completely free with no obligation or sales pressure.",
  },
  {
    q: "Can you work with international clients?",
    a: "Yes. We work with clients across India, UAE, Europe, and the US, aligned to your timezone.",
  },
];

export default function StartFAQ() {
  return (
    <section className="sp-faq">
      <div className="sp-faq-inner">
        <span className="sp-faq-badge">FAQs</span>

        <h2 className="sp-faq-title">
          Common Questions, <span>Clear Answers</span>
        </h2>

        <p className="sp-faq-sub">
          Everything you need to know before starting your project with Oglitz.
        </p>

        <div className="sp-faq-list">
          {faqs.map((item, i) => (
            <details key={i} className="sp-faq-card">
              <summary>
                <span>{item.q}</span>
                <FiPlus className="icon" />
              </summary>
              <div className="answer">{item.a}</div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
